module.exports = __webpack_public_path__ + "media/images/general/parent_03-00e5b571f1240246341b1701404f7300.png";